export const TRANSLATION_GROUP_HEADER = Symbol('header');
export const TRANSLATION_SUPERVISION_NOTIFICATION_GROUP_HEADER = Symbol('supervision-notification');
